
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/figma-design-backup",
      function () {
        return require("private-next-pages/figma-design-backup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/figma-design-backup"])
      });
    }
  